module.exports = __webpack_public_path__ + "img/drinks.a49d57d.jpg";